// extracted by mini-css-extract-plugin
module.exports =  {"root":"oUM_VKdIGB95RLR5RBeg"};